import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import CommonCard from "../../../commoncomponents/layout/card/CommonCard";
import { Backdrop, CircularProgress, Grid, Typography } from "@mui/material";
import classes from "../servicedetails/ServiceDetails.module.css";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import InputField from "../../../commoncomponents/input/InputField";
import {
  mobileNoRegex,
  phoneNoRegex,
} from "../../../commoncomponents/input/Regex";
import * as Yup from "yup";
import ButtonComponent from "../../../commoncomponents/buttons/ButtonComponent";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import Box from "@mui/material/Box";
import {
  useFormik,
  ErrorMessage,
  FieldArray,
  FormikProvider,
  getIn,
} from "formik";
import {
  getRequest,
  postAxios,
  singoutHandler,
} from "../../../../api/AxiosAPICall";
import CommonLayout from "../../../commoncomponents/layout/CommonLayout";
import { nanoid } from "nanoid";
const ServicesInformation = ({ mode }: { mode: any }) => {
  const isMounted = useRef<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [headerButton, setHeaderButton] = useState(true);
  const dispatch = useDispatch();
  let history = useNavigate();
  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  useEffect(() => {
    isMounted.current = true;
    if (mode !== undefined) {
      setHeaderButton(true);
    } else {
      setHeaderButton(false);
    }
    return () => {
      isMounted.current = false;
    };
  }, [mode]);
  const isError = (value: any) => {
    let error =
      Boolean(getIn(formik.touched, value)) &&
      Boolean(getIn(formik.errors, value));
    return error;
  };
  const handleSave = async (index: number, formik: any) => {
    formik.handleSubmit();
    const response = await postAxios(
      "updateClinicLocationAddressDetails",
      {},
      {
        params: {
          clinicLocationId: parseInt(
            formik.values.serviceTypeDetails[index].cloId
          ),
          email: formik.values.serviceTypeDetails[index].email,
          mobile: formik.values.serviceTypeDetails[index].mobile,
          phone: formik.values.serviceTypeDetails[index].phoneNumber,
        },
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          4000,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else if (response.data.addressUpdated) {
      dispatch(
        setSnackbar(
          true,
          4000,
          "success",
          "Service information updated successfully!",
          "top",
          "center"
        )
      );
    } else if (!response.data.addressUpdated) {
      dispatch(
        setSnackbar(
          true,
          4000,
          "warning",
          "Service information update failed.",
          "top",
          "center"
        )
      );
    }
  };
  const fetchClinicLocation = useCallback(async () => {
    const response = await getRequest("userClinicTypesDetails", {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else {
      if (
        response?.data !== undefined &&
        response?.data !== null &&
        response?.data !== ""
      ) {
        response?.data?.forEach((element: any, index: any) => {
          formik.setFieldValue(
            `serviceTypeDetails[${index}].clinicName`,
            element.clinicName ? element.clinicName : ""
          );
          formik.setFieldValue(
            `serviceTypeDetails[${index}].addId`,
            element.addId ? element.addId : ""
          );
          formik.setFieldValue(
            `serviceTypeDetails[${index}].cloId`,
            element.cloId ? element.cloId : ""
          );
          formik.setFieldValue(
            `serviceTypeDetails[${index}].serviceType`,
            element.clinicTypeEliText ? element.clinicTypeEliText : ""
          );
          formik.setFieldValue(
            `serviceTypeDetails[${index}].serviceLocation`,
            element.clinicLocationEliText ? element.clinicLocationEliText : ""
          );
          formik.setFieldValue(
            `serviceTypeDetails[${index}].phoneNumber`,
            element.phone ? element.phone : ""
          );
          formik.setFieldValue(
            `serviceTypeDetails[${index}].mobile`,
            element.mobile ? element.mobile : ""
          );
          formik.setFieldValue(
            `serviceTypeDetails[${index}].email`,
            element.email ? element.email : ""
          );
        });
        setIsLoading(false);
      }
    }
  }, [dispatch, history, jwtToken]);

  useEffect(() => {
    isMounted.current = true;
    setIsLoading(true);
    fetchClinicLocation();

    return () => {
      setIsLoading(false);
      isMounted.current = false;
    };
    // eslint-disable-next-line
  }, []);
  const formik = useFormik({
    initialValues: {
      serviceTypeDetails: [
        {
          clinicName: "",
          addId: "",
          cloId: "",
          serviceType: "",
          serviceLocation: "",
          mobile: "",
          phoneNumber: "",
          email: "",
        },
      ],
    },
    validationSchema: Yup.object({
      serviceTypeDetails: Yup.array().of(
        Yup.object({
          email: Yup.string()
            .email("Please enter valid email.")
            .required("Please enter valid email."),
          phoneNumber: Yup.string().matches(
            phoneNoRegex,
            "Please enter valid phone number"
          ),
          mobile: Yup.string().matches(
            mobileNoRegex,
            "Please enter valid mobile number"
          ),
        })
      ),
    }),
    onSubmit: async () => {},
  });

  return (
    <CommonLayout
      showHeaderNavigation={headerButton}
      isLogedIn={headerButton === false ? false : true}
    >
      <Fragment>
        <CommonCard>
          <Grid container>
            <Grid item md={12}>
              <Typography variant="h1" className={globalClasses.typography}>
                Service Location Information
              </Typography>
            </Grid>
            <FormikProvider value={formik}>
              <FieldArray
                name="serviceTypeDetails"
                render={() => (
                  <Box>
                    {formik?.values?.serviceTypeDetails?.map(
                      (details: any, index: number) => {
                        return (
                          <Grid container item sx={{ marginBottom: "20px" }} key={nanoid()}>
                            <Grid
                              container
                              item
                              spacing={2}
                              className={classes.rowSpace}
                              direction="row"
                              sx={{ marginBottom: "20px" }}
                            >
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                md={3.3}
                                sx={{ display: "flex" }}
                              >
                                <InputField
                                  id={`serviceTypeDetails[${index}].clinicName`}
                                  name={`serviceTypeDetails[${index}].clinicName`}
                                  label="Clinic Name"
                                  inputvalues={details.clinicName ?? ""}
                                  disable={true}
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                md={3.3}
                                sx={{ display: "flex" }}
                              >
                                <InputField
                                  id={`serviceTypeDetails[${index}].serviceType`}
                                  name={`serviceTypeDetails[${index}].serviceType`}
                                  label="Service Type"
                                  inputvalues={details.serviceType ?? ""}
                                  disable={true}
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                md={3.3}
                                sx={{ display: "flex" }}
                              >
                                <InputField
                                  id={`serviceTypeDetails[${index}].serviceLocation`}
                                  name={`serviceTypeDetails[${index}].serviceLocation`}
                                  label="Service Location"
                                  inputvalues={details.serviceLocation ?? ""}
                                  disable={true}
                                />
                              </Grid>
                              <input
                                type="hidden"
                                id={`serviceTypeDetails[${index}].addId`}
                                name={`serviceTypeDetails[${index}].addId`}
                                value={details.addId ?? ""}
                                onChange={formik.handleChange}
                              />
                              <input
                                type="hidden"
                                id={`serviceTypeDetails[${index}].cloId`}
                                name={`serviceTypeDetails[${index}].cloId`}
                                value={details.cloId ?? ""}
                                onChange={formik.handleChange}
                              />
                            </Grid>
                            <Grid
                              container
                              spacing={2}
                              className={classes.rowSpace}
                              direction="row"
                              sx={{ marginBottom: "20px" }}
                            >
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                md={3.3}
                                className={classes.formControlZeroMarginTop}
                              >
                                <InputField
                                  id={`serviceTypeDetails[${index}].email`}
                                  name={`serviceTypeDetails[${index}].email`}
                                  label="Email Id"
                                  inputvalues={details.email ?? ""}
                                  changeevent={(event: any) => {
                                    formik.handleChange(event);
                                  }}
                                  blurevent={(event: any) => {
                                    formik.handleBlur(event);
                                  }}
                                  isrequired={true}
                                  errormessage={isError(
                                    `serviceTypeDetails[${index}].email`
                                  )}
                                  message={
                                    <ErrorMessage
                                      name={`serviceTypeDetails[${index}].email`}
                                    />
                                  }
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                md={3.3}
                                className={classes.formControlZeroMarginTop}
                              >
                                <InputField
                                  id={`serviceTypeDetails[${index}].mobile`}
                                  name={`serviceTypeDetails[${index}].mobile`}
                                  label="Mobile"
                                  inputvalues={details.mobile ?? ""}
                                  changeevent={(event: any) => {
                                    formik.handleChange(event);
                                  }}
                                  blurevent={(event: any) => {
                                    formik.handleBlur(event);
                                  }}
                                  errormessage={isError(
                                    `serviceTypeDetails[${index}].mobile`
                                  )}
                                  message={
                                    <ErrorMessage
                                      name={`serviceTypeDetails[${index}].mobile`}
                                    />
                                  }
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                md={3.3}
                                className={classes.formControlZeroMarginTop}
                              >
                                <InputField
                                  id={`serviceTypeDetails[${index}].phoneNumber`}
                                  name={`serviceTypeDetails[${index}].phoneNumber`}
                                  label="Phone Number"
                                  inputvalues={details.phoneNumber ?? ""}
                                  changeevent={(event: any) => {
                                    formik.handleChange(event);
                                  }}
                                  blurevent={(event: any) => {
                                    formik.handleBlur(event);
                                  }}
                                  errormessage={isError(
                                    `serviceTypeDetails[${index}].phoneNumber`
                                  )}
                                  message={
                                    <ErrorMessage
                                      name={`serviceTypeDetails[${index}].phoneNumber`}
                                    />
                                  }
                                />
                              </Grid>
                              {mode === "edit" && (
                                <Grid item xs={12} sm={4} md={2}>
                                  <form>
                                    <ButtonComponent
                                      variant="contained"
                                      size="small"
                                      type="button"
                                      buttonclass={classes.nextButton}
                                      onClick={(event: any) => {
                                        if (
                                          getIn(
                                            formik.errors,
                                            `serviceTypeDetails[${index}].email`
                                          ) ||
                                          getIn(
                                            formik.errors,
                                            `serviceTypeDetails[${index}].mobile`
                                          )
                                        ) {
                                          formik.setFieldTouched(
                                            `serviceTypeDetails[${index}].email`
                                          );
                                          formik.setFieldTouched(
                                            `serviceTypeDetails[${index}].mobile`
                                          );
                                        } else {
                                          handleSave(index, formik);
                                        }
                                      }}
                                      buttontitle="Save"
                                      label="Save"
                                    />
                                  </form>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        );
                      }
                    )}
                  </Box>
                )}
              />
            </FormikProvider>
          </Grid>
          {mode === "edit" && isLoading && (
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: 1500,
                display: "flex",
                flexDirection: "column",
              }}
              open
            >
              <Typography fontWeight="600" fontSize="20px">
                Loading Service Information...!
              </Typography>
              <CircularProgress color="primary" sx={{ margin: "20px" }} />
            </Backdrop>
          )}
        </CommonCard>
      </Fragment>
    </CommonLayout>
  );
};

export default ServicesInformation;
